function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsiaone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 190.08,
    height: 28.8,
    viewBox: "0 0 190.08 28.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M698.78,345.55c0-9.59,7-14.37,13.49-14.37,5,0,8.27,2.72,9,4.25h.16v-3.71h7.22v27.69h-7.19v-3.72h-.16c-.7,1.53-3.93,4.25-9,4.25C705.75,359.91,698.78,355.13,698.78,345.55Zm22.81,0a7.55,7.55,0,0,0-7.16-8,4.09,4.09,0,0,0-.7,0,7.65,7.65,0,0,0-7.86,7.36v.6a7.57,7.57,0,0,0,7.23,8h.6a7.61,7.61,0,0,0,7.86-7.31A4.79,4.79,0,0,0,721.59,345.55Zm9.91,6.58,5.77-1.53a4.73,4.73,0,0,0,4.65,3.69c1.84,0,3.62-.91,3.62-2.87,0-1.35-.86-2.28-3.08-3.13L739,347c-4.66-1.65-6.59-4.59-6.59-7.93-.06-4.93,4.37-7.9,9.63-7.9,5.07,0,8.81,2.81,9.73,7.09l-5.64,1.44a3.76,3.76,0,0,0-3.74-2.94c-1.9,0-3,1-3,2.41,0,1.18.7,2.18,2.92,2.93l3.16,1.19c3.46,1.22,7.23,3.25,7.23,8.15,0,5.52-4.82,8.52-10.68,8.52C736.44,359.91,732.33,357.25,731.5,352.13Zm24.21-20.41H763v27.69h-7.25ZM766,345.55c0-9.59,7-14.37,13.5-14.37,5,0,8.27,2.72,9,4.25h.15v-3.71h7.23v27.69h-7.26v-3.72h-.12c-.7,1.53-3.93,4.25-9,4.25C773,359.91,766,355.13,766,345.55Zm22.81,0a7.84,7.84,0,0,0-15.68,0h0a7.84,7.84,0,0,0,15.68,0Z",
    transform: "translate(-698.78 -331.17)",
    style: {
      fill: "#343838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.58,331.18A14.37,14.37,0,1,1,799,345.55,14.48,14.48,0,0,1,813.58,331.18Zm44.13,11.93v16.3h-7.22V344.3c0-4.06-2.22-6.71-6-6.71s-6,2.65-6,6.71v15.11h-7.25V331.72h7.22v3.77a9.67,9.67,0,0,1,8.59-4.31C852.83,331.18,857.71,334.68,857.71,343.11Zm30.95,5.21h-21c1,3.78,4.37,5.75,8.58,5.75a10.69,10.69,0,0,0,7.23-2.5L886.7,355a14.49,14.49,0,0,1-11.34,4.9c-7.73,0-14.64-5.21-14.64-14.36A13.92,13.92,0,0,1,875,331.22C882.17,331.18,890.22,336.12,888.66,348.32Zm-21.13-5.21h14.7c-.44-4-3.8-5.9-7.19-5.9a7.39,7.39,0,0,0-7.51,5.9Z",
    transform: "translate(-698.78 -331.17)",
    style: {
      fill: "#343838"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsiaone);
export default __webpack_public_path__ + "static/media/ASIAONE.bf7e22305254220350061bafc055183b.svg";
export { ForwardRef as ReactComponent };